import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=d480ea6e&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=d480ea6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d480ea6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d480ea6e')) {
      api.createRecord('d480ea6e', component.options)
    } else {
      api.reload('d480ea6e', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=d480ea6e&scoped=true&", function () {
      api.rerender('d480ea6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2l8Ra0XPppbwW/JS/teamMember.vue"
export default component.exports